import { InjectionKey } from "@lib/svelte-typed-context";

import { VideoController } from "./VideoController";

export const videoControllerToken: InjectionKey<VideoController> =
    Symbol("videoController");
